import { z } from "zod";
import { MCP_TOKEN_NAME_MAX_LENGTH } from "./mcp-constants.js";
export const createMcpTokenSchema = z.object({
    name: z.string().min(1).max(MCP_TOKEN_NAME_MAX_LENGTH).trim(),
});
export const mcpTokenSchema = z.object({
    id: z.string(),
    name: z.string(),
    token_prefix: z.string(),
    expires_at: z.iso.datetime(),
    last_used_at: z.iso.datetime().nullable(),
    created_at: z.iso.datetime(),
});
export const mcpTokenCreatedSchema = z.object({
    token: mcpTokenSchema,
    secret: z.string(),
});
